import { ModalBodyProps } from '@/shared/types/modal';
import { cn } from '@/shared/utils/cn';
import { useModalContext } from '../../context';

export const ModalBody = ({ children, withPadding = true }: ModalBodyProps) => {
  const { hideFooter, sectionPadding = 'md' } = useModalContext();
  const sectionPaddingClass = sectionPadding === 'sm' ? 'ui-p-8' : 'ui-p-16';

  return (
    <div
      data-imj-modal-body=""
      className={cn(
        withPadding && sectionPaddingClass,
        hideFooter && 'ui-rounded-b-lg', // Aplicar border-radius inferior cuando el footer está oculto
      )}
    >
      {children}
    </div>
  );
};
